import * as React from "react";
const SvgSpinner = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, fill: "none", viewBox: "0 0 48 48", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "rgba(233, 108, 25, 1)", strokeLinecap: "round", strokeWidth: 8, d: "M44 24a20 20 0 1 1-40 0" }));
export default SvgSpinner;
